import { ShortageStatus } from 'src/app/entities/products/enums/shortage-status.enum';
import { MapWithDefault } from '@app-shared/functions/helpers.functions';

/** Limit number after which a warning shows in the products table to limit the filters */
export const DEFAULT_PRODUCTS_LIMIT_WARNING_NUMBER = 300;

export const MIN_PRODUCT_TABLE_COLUMNS_SELECTED = 3;
export const MAX_PRODUCT_TABLE_COLUMNS_SELECTED = 10;

/** Number that determines how many products can be exported at maximum */
export const MAX_PRODUCTS_EXPORT_NUMBER = 10_000;
export const MAX_PRODUCTS_EXPORT_NUMBER_WITH_ALTERNATIVES = 2000;

/** Shortage statuses that need to have primary(blue) colored buttons */
export const POSITIVE_SHORTAGE_STATUSES = [
  ShortageStatus.Available,
  ShortageStatus.BackInStock,
  ShortageStatus.Limited,
];

export const shortageStatusIconMap = new MapWithDefault<ShortageStatus, string>(
  'close',
);
shortageStatusIconMap.set(ShortageStatus.Available, 'check');
shortageStatusIconMap.set(ShortageStatus.BackInStock, 'check');
shortageStatusIconMap.set(ShortageStatus.Limited, 'error_outline');
